import {RegistrationFormData} from '../../components/form/RegisterForm';
import {transformRegistration} from '../shared/utils/registration-utils';
import {LegalForm} from '../data/types/registration/legal-form';

const ciselnik_url = process.env.REACT_APP_URL_BACKEND_TS_CISELNIKY;
const registration_url = process.env.REACT_APP_URL_REGISTRACE_TA;
const get_existing_clinet_url = process.env.REACT_APP_URL_GET_EXISTING_CLIENT;
const get_existing_user_url = process.env.REACT_APP_URL_GET_EXISTING_USER;

export async function getLegalForms(): Promise<LegalForm[] | null> {
	try {
		const response = await fetch(ciselnik_url + '/naseptavac/pravni-formy', {
			method: 'GET',
			headers: {'Content-Type': 'application/json'}
		});

		if (!response.ok) {
			return;
		}

		return await response.json();
	} catch (err) {
		return null;
	}
}

export async function submitFormData(formData: RegistrationFormData) {
	try {
		const registerData = transformRegistration(formData);
		const response = await fetch(registration_url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(registerData),

		});

		if (!response.ok) {
			return await response.json();
		}
		return response;

	} catch (error) {
		throw error;
	}
}

export async function getExistingClient(ico: string) {
	const urlWithUser = get_existing_clinet_url + ico;
	try {
		const response = await fetch(urlWithUser, {
			method: 'GET',
		});

		const json = await response.json();

		return {
			ok: response.ok,
			...json,
		};

	} catch (error) {
		throw error;
	}
}

export async function getExistingUser(username: string) {
	const urlWithUser = get_existing_user_url + username;
	try {
		const response = await fetch(urlWithUser, {
			method: 'GET',
		});

		const json = await response.json();

		return {
			ok: response.ok,
			...json,
		};

	} catch (error) {
		throw error;
	}
}
